import React, { useEffect, useState, useRef } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Drawer,
  Descriptions,
  Anchor,
  Tag,
  notification,
  Modal,
  Input,
  Form,
  DatePicker,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Table } from "ant-table-extensions";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";
import _ from "lodash";
import "./style.css";
import moment from "moment";

function DiwaliBonanza2026DailyWinners() {
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const [btnloading, setbtnloading] = useState(false);
  const [form] = Form.useForm();
  const [dates, setDates] = useState(null);
  const [formError, setFormError] = useState({});

  const { RangePicker } = DatePicker;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const moduleNamePural = "Dream Big Win Bigger 2026 Daily Winners";
  const base_url =
    config.api_url + "admin/leads/diwali-bonanza-2026"; //without trailing slash

  const azure_object_url =
    config.azure_object_url + "public/uploads/diwali-bonanza-2026/";
  const { Link } = Anchor;

  const handleView = async (id) => {
    const result = await http.get(
      `${base_url}/daily-winners/${id}`
    );
  
    if (result) {
      setData(result.data.entry);
      setdraweropen(true);
    }
  };

  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };

  const fetchDatas = async (fromDate = null, toDate = null) => {
    setloading(true);
  
    const result = await http.get(
      `${base_url}/daily-winners`,
      {
        params: {
          verified: true,
          fromDate,
          toDate,
        },
      }
    );
  
    if (result) {
      const rows = result.data.winners.map((winner) => ({
        ...winner.entry,
        winnerId: winner._id,
        voucher: winner.voucher,
        batch: winner.batch,
        verified_at: winner.verified_at,
        createdAt: winner.entry.createdAt,
      }));
  
      setDatas(rows);
    } else {
      setDatas([]);
    }
  
    setloading(false);
  };

  const handleSubmit = async (value) => {
    if (!dates) {
      setFormError({ dates: "Please select a date" });
    }

    if (dates) {
      setFormError({});
      setbtnloading(true);
      fetchDatas(dates[0], dates[1]);
      setbtnloading(false);
    }
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      return (
        <div
          style={{
            padding: 8,
          }}
        >
          <Input
            autoFocus
            placeholder="Type text here"
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => {
              confirm();
            }}
            onBlur={() => {
              confirm();
            }}
            style={{
              marginBottom: 8,
              display: "block",
            }}
          ></Input>
          <Space>
            {/* <Button
           onClick={() => {
            clearFilters();
            setSelectedKeys(selectedKeys[0]);
            confirm();
           

          }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button> */}
          </Space>
        </div>
      );
    },
    filterIcon: () => {
      return <SearchOutlined />;
    },
    onFilter: (value, record) => {
      return String(record[dataIndex] || "")
        .toLowerCase()
        .includes(value.toLowerCase());
    },
  });

  const columns = [
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      ellipsis: true,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      ellipsis: true,
    },
    {
      title: "Email Id",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Contact Number",
      dataIndex: "phone",
      key: "phone",
      render: (text, record) => {
        if (record.country_code && record.phone) {
          return `${record.country_code} ${record.phone}`;
        }
      
        if (record.phone) {
          return record.phone;
        }
      
        return "NA";
      },
    },
    // {
    //   title: "Gender",
    //   dataIndex: "gender",
    //   key: "gender",
    // },
    // {
    //   title: "Date of Birth",
    //   dataIndex: "date_of_birth",
    //   key: "date_of_birth",
    //   render: (text) => {
    //     return text ? helper.UserDate(text, "-04:00", "MM/DD/YYYY") : "-";
    //   },
    // },
    // {
    //   title: "Country",
    //   dataIndex: "country",
    //   key: "country",
    // },
    // {
    //   title: "State",
    //   dataIndex: "state",
    //   key: "state",
    // },
    // {
    //   title: "City",
    //   dataIndex: "city",
    //   key: "city",
    //   render: (text, record) => {
    //     return _.replace(_.deburr(record.city), /'/g, "") || "-";
    //   },
    // },
    // {
    //   title: "Invoice Uploaded",
    //   dataIndex: "is_invoice_uploaded",
    //   key: "is_invoice_uploaded",
    //   render: (text, record) => {
    //     return record.is_invoice_uploaded ? (
    //       <Tag color="green">Yes</Tag>
    //     ) : (
    //       <Tag color="red">No</Tag>
    //     );
    //   },
    // },
    {
      title: "Created At",
      render: (text, record) => {
        return helper.UserDate(record.createdAt, "-04:00");
      },
      key: "createdAt",
      dataIndex: "createdAt",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              handleView(record.winnerId);
            }}
          >
            View Detail
          </Button>
        </Space>
      ),
    },
  ];

  const fields: ITableExportFields = {
    first_name: "First Name",
    last_name: "Last Name",

    phone: {
      header: "Contact Number",
      formatter: (_fieldValue, record) => {
        if (record.country_code && record.phone) {
          return `${record.country_code} ${record.phone}`;
        }
    
        if (record.phone) {
          return record.phone;
        }
    
        return "NA";
      },
    },
    email: "Email Id",
    gender: "Gender",
    date_of_birth: {
      header: "Date of Birth",
      formatter: (_fieldValue, record) => {
        return record.date_of_birth
          ? `="${moment(record.date_of_birth).format("DD-MMM-YYYY")}"`
          : "NA";
      },
    },
    address: {
      header: "Address",
      formatter: (_fieldValue, record) => {
        return record.address || "NA";
      },
    },

    country: "Country",
    state: "State",

    city: {
      header: "City",
      formatter: (_fieldValue, record) => {
        return record.city
          ? _.replace(_.deburr(record.city), /'/g, "")
          : "NA";
      },
    },
    zip: "Zip Code",
    store: "Which store did you buy this Laxmi product from?",
    campaign_source: "How did you get to know about this campaign?",
    laxmi_ads_desc: "Have you seen Laxmi ads before? if yes where?",
    laxmi_fav_product: "What is your favorite product from Laxmi?",
    laxmi_brand_one_word: {
      header: "Can you Describe Laxmi Brand in one word?",
      formatter: (_fieldValue, record) => {
        return record.laxmi_brand_one_word || "NA";
      },
    },

    invoice: {
      header: "Invoice",
      formatter: (_fieldValue, record) => {
        return record.invoice ? azure_object_url + record.invoice : "NA";
      },
    },

    is_invoice_uploaded: {
      header: "Invoice Uploaded",
      formatter: (_fieldValue, record) => {
        return record.is_invoice_uploaded ? "Yes" : "No";
      },
    },

    createdAt: {
      header: "Created At",
      formatter: (_fieldValue, record) => {
        return helper.UserDate(record.createdAt, "-04:00");
      },
    },
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>
      <Row gutter={15}>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Form layout="inline" form={form} onFinish={handleSubmit}>
                <Form.Item
                  label="Date:"
                  name="date"
                  {...(formError.dates && {
                    help: formError.dates,
                    validateStatus: "error",
                  })}
                >
                  <RangePicker
                    value={dates}
                    placeholder={["From", "To"]}
                    variant="borderless"
                    onChange={(date, datestring) => {
                      setDates(datestring);
                    }}
                  />
                </Form.Item>

                <Form.Item>
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={btnloading}
                    >
                      Filter
                    </Button>
                    <Button
                      type="secondary"
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      Reset
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card bordered={false}>
            <Table
              rowKey={(record) => record._id}
              columns={columns}
              dataSource={datas}
              loading={loading}
              pagination={{
                defaultPageSize: 10,
                pageSizeOptions: ["10", "20", "50", "100"],
                showSizeChanger: true,
                // showQuickJumper: true,
              }}
              exportableProps={{
                fields,
                fileName: moduleNamePural,
              }}
              searchableProps={{
                fuzzySearch: false,
                fuseProps: {
                  useExtendedSearch: true,
                },
              }}
            />
            </Card>

            <Drawer
              title="Lead Details"
              placement="right"
              onClose={handleDrawerClose}
              visible={drawerOpen}
              size="large"
            >
              {data && (
                <Descriptions
                  bordered
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                >
                  <Descriptions.Item label="First Name">
                    {data.first_name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Last Name">
                    {data.last_name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Contact Number">
                    {data.country_code && data.phone
                      ? `${data.country_code} ${data.phone}`
                      : data.phone || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email Id">
                    {data.email}
                  </Descriptions.Item>
                  <Descriptions.Item label="Gender">
                    {data.gender}
                  </Descriptions.Item>
                  <Descriptions.Item label="Date of Birth">
                    {data.date_of_birth
                      ? moment(data.date_of_birth).format("D MMMM YYYY")
                      : "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Address">
                  {data.address || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Country">
                    {data.country || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="State">
                    {data.state || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="City">
                    {_.replace(_.deburr(data.city), /'/g, "") || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Zip Code">
                    {data.zip || "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Which store did you buy this Laxmi product from?">
                    {data.store}
                  </Descriptions.Item>
                  <Descriptions.Item label="How did you get to know about this campaign?">
                    {data.campaign_source}
                  </Descriptions.Item>
                  <Descriptions.Item label="Have you seen Laxmi ads before? if yes where?">
                    {data.laxmi_ads_desc}
                  </Descriptions.Item>
                  <Descriptions.Item label="What is your favorite product from Laxmi?">
                    {data.laxmi_fav_product}
                  </Descriptions.Item>
                  <Descriptions.Item label="Can you Describe Laxmi Brand in one word?">
                    {data.laxmi_brand_one_word || "NA"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Invoice">
                    {data.invoice ? (
                      <a
                        href={azure_object_url + data.invoice}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View Invoice
                      </a>
                    ) : (
                      "NA"
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Invoice Uploaded">
                    {data.is_invoice_uploaded ? (
                      <Tag color="green">Yes</Tag>
                    ) : (
                      <Tag color="red">No</Tag>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At">
                    {helper.UserDate(data.createdAt, "-04:00")}
                  </Descriptions.Item>
                </Descriptions>
              )}
            </Drawer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default DiwaliBonanza2026DailyWinners;
